(function (w, d) {
	const sidebarNav = d.querySelector('.js-sidebar-nav');
	const items = d.querySelectorAll('.js-for-sidebar-nav');
	const policy = d.querySelector(".js-policy");
	const terms = d.querySelector(".js-terms");
	const container = terms || policy;
	const throttleTime = 150;
	if (!container) return;

	function createLi(id, heading) {
		const li = d.createElement('li');
		const a = d.createElement('a');

		a.href = '#' + id;
		a.classList.add('sidebar__nav-item-link', 'js-anchor-scroll');
		a.innerHTML = heading;
		a.addEventListener('click', function scrollTo(e) {
			e.preventDefault();
			const section = d.querySelector(e.target.hash);

			if (w.innerWidth < 768) {
				const position = section.offsetTop + 100;
				smoothScrollTo(position)
			} else {
				const position = section.offsetTop;
				smoothScrollTo(position)
			}
		});

		li.classList.add('sidebar__nav-item');
		li.appendChild(a);

		return li;
	}

	for (let i = 0; i < items.length; i++) {
		const sidebarId = items[i].id;
		const heading = items[i].querySelector('.js-sidebar-subtitle').innerHTML;
		const li = createLi(sidebarId, heading);
		sidebarNav.appendChild(li);
	}

	function smoothScrollTo(position) {
		w.smoothScrollTo(0, position, 450);
	}

	const sidebarLinks = d.querySelectorAll(".js-anchor-scroll");
	if (!sidebarLinks) return;

	updateScroll = throttle(updateScroll, throttleTime);

	w.addEventListener("scroll", updateScroll);

	function updateScroll() {
		if (w.innerWidth < 768) return;
		let scrollTop = w.pageYOffset + 150;

		sidebarLinks.forEach(link => {
			const section = d.querySelector(link.hash);
			if (
				section.offsetTop <= scrollTop &&
				section.offsetTop + section.offsetHeight > scrollTop
			) {
				link.classList.add("sidebar__nav-item-link_active");
			} else {
				link.classList.remove("sidebar__nav-item-link_active");
			}
		});
	}
})(window, document);

